// Application Compliance Trend is temporarily disabled — see the commented-out
// block at the bottom of this file. Restore this import together with it.
// import { PostureTrendWidget } from "./PostureTrendWidget";
import { ApplicationComplianceWidget } from "./ApplicationComplianceWidget";
import { FailedControlRemediationWidget } from "./FailedControlRemediationWidget";
import { ControlFailureRateWidget } from "./ControlFailureRateWidget";
import { PendingAssessmentWidget } from "./PendingAssessmentWidget";
import { ReviewVelocityWidget } from "./ReviewVelocityWidget";

/* ══════════════════════════════════════════════════════════════════════
   APPLICATION MANAGER KRI OVERVIEW — main export
   Pure layout. The old GRC rollup call (GET /dashboard/grc/applications-ssps)
   404s and is no longer called from anywhere; every widget below now fetches
   its own dedicated system-owner endpoint and owns its loading/error state:

     - Application Compliance Score       -> /system-owner/control-compliance
     - Failed Control Remediation Status  -> /system-owner/remediation-status
     - Controls with Highest Failure Rate -> /system-owner/control-failure-rates
     - Assessment Review Velocity         -> /system-owner/review-velocity
     - Controls Yet to be Assessed        -> /system-owner/unassessed-controls
     - Application Compliance Trend       -> /system-owner/compliance-trend

   One widget failing therefore no longer blanks out the others.
   ══════════════════════════════════════════════════════════════════════ */
export function ApplicationKRIOverview() {
  return (
    <div className="space-y-4">
      {/* Application Compliance Score — assessment-based, answers "how
          compliant is my application" directly, so it leads the page ahead
          of the control-level KRI widgets below. */}
      <div id="widget-application-compliance">
        <ApplicationComplianceWidget />
      </div>

      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
        <div id="widget-failed-control-remediation">
          <FailedControlRemediationWidget />
        </div>
        <div id="widget-failure-rate">
          <ControlFailureRateWidget />
        </div>
      </div>

      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
        <div id="widget-review-velocity">
          <ReviewVelocityWidget />
        </div>
        <PendingAssessmentWidget />
      </div>

      {/* ── Application Compliance Trend — TEMPORARILY DISABLED ────────────
          The card is commented out, which also stops its API call: the widget
          only calls GET /system-owner/compliance-trend from a useEffect on
          mount, so an unmounted widget never fires the request. Nothing else
          renders PostureTrendWidget, and the component file is left intact.

          To re-enable: un-comment the block below AND the PostureTrendWidget
          import at the top of this file.

          It sat full width because it is the only time-series here, and the
          extra width buys months on the x-axis while keeping the half-width
          rows above paired with no empty cell.

      <div id="widget-posture-trend">
        <PostureTrendWidget />
      </div>
      ─────────────────────────────────────────────────────────────────── */}
    </div>
  );
}
